import { observable } from 'mobx';

export class UIState {
    @observable public static isExportingToImage = false;
    public static isExportingElementImage = false;
}
